import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import Modal from "react-modal";
import store from "./store/store";
import App from "./App";
import "./index.css";

// Set app element for React-Modal accessibility
Modal.setAppElement("#root");

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Provider>
);

